export const Small = "Small";
export const SmallMedium = "SmallMedium";
export const Medium = "Medium";
export const Large = "Large";
export const VeryLarge = "VeryLarge";


export const All = [ Small, SmallMedium, Medium, Large, VeryLarge ];